import { Box, Image, Text } from '@chakra-ui/react';
import { type AnnouncementContentProps } from '../announcementConfig';
import googlePassUpdateImage from '../../../../assets/images/announcements/google-pass-update.svg';

const GooglePassUpdateContent = ({ dots }: AnnouncementContentProps) => (
  <Box>
    <Box px={10} pb={6} textAlign="center">
      <Text textStyle="heading3" lineHeight="1.2" color="white">
        Google passes just
        <br />
        got a new look
      </Text>
      {dots}
    </Box>

    <Box bg="white">
      <Box px={10} py={6}>
        <Image
          src={googlePassUpdateImage}
          alt="Google pass old design vs new design comparison"
          w="85%"
          mx="auto"
        />
      </Box>

      <Text
        textStyle="bodyFamilyRegular"
        fontSize="16px"
        lineHeight="1.6"
        px={10}
        mb={6}
      >
        Richer colours, a bold hero image and your brand front and centre.
        Customers now{' '}
        <Text as="span" textStyle="bodyFamilyBold">
          scroll to see more
        </Text>{' '}
        — no more flipping to the back.
      </Text>
    </Box>
  </Box>
);

export default GooglePassUpdateContent;
